export default __webpack_public_path__ + "static/header-educational-content-b51ff199c2d7db1f26102d39df09804d.png";